// extracted by mini-css-extract-plugin
export default {"root":"ToggleChip_root__YnBT3","active":"ToggleChip_active__RqQXW"};